import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import AddUnit from "../components/AddUnit";

class AddUnitContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deals: [],
      isLoading: true
    };
  }
  addUnit = unit => {
    this.props.db.collection("units").add(unit);
  };
  render() {
    const { user } = this.props;
    return <AddUnit addUnit={this.addUnit} user={user} />;
  }
}

export default withRouter(withUser(withFirebase(AddUnitContainer)));
